<template>
  <div class="container">
    <div class="row" v-if="number">
      <div class="col-sm-12 col-md-4 my-auto">
        <Search
          @search="numberSearch"
          :min="10"
          :max="11"
          placeholder="Search by number"
          description="Telephone"
          :reset="numberReset"
        />
      </div>
      <div class="col-sm-12 col-md-4 my-auto">
        <Search
          @search="numberByAccountSearch"
          :min="1"
          :max="6"
          :reset="accountReset"
          placeholder="Search by account id"
          description="Account"
        />
      </div>
      <div class="col-sm-12 col-md-4 text-center my-auto">
        <div v-if="numberList">
          <NumberList
            :numbers="numberList"
            :account="accountIdSearch"
            @numberUpdated="numberUpdated"
          />
        </div>
        <div class="my-auto alert alert-success display-6" v-else-if="number && !numberList">{{ number }}</div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <div class="col-sm-8">
        <Welcome
          @searchNum="numberSearch"
          @searchAcc="numberByAccountSearch"
          @updated="numberUpdated"
          :numberList="numberList"
        />
      </div>
    </div>
    <div class="row mt-2" v-if="number">
      <div class="col-md-3 mb-3">
        <Suspense>
          <template #default>
            <AccountBar :number="number" />
          </template>
          <template #fallback>
            <AccountBarSkeleton />
          </template>
        </Suspense>
      </div>
      <!-- end sidebar -->

      <div class="col">
        <div class="row justify-content-center text-center" v-if="number">
          <Suspense>
            <template #default>
              <MagratheaCard 
              :number="number"
              :carrierType="carrierType" />
            </template>
            <template #fallback>
              <ProfileCardSkeleton />
            </template>
          </Suspense>
          <TwilioCard :number="number" />
        </div>

        <div v-if="number">
          <Suspense>
            <template #default>
              <NumberCard 
                :number="number" 
                @carrierTypeUpdated="carrierTypeUpdated"  
              />
            </template>
            <template #fallback>
              <div class="row justify-content-center text-center">
                <ProfileCardSkeleton
                  v-for="index in numberTiles"
                  :key="index"
                />
              </div>
            </template>
          </Suspense>
        </div>
      </div>
    </div>

    <div v-if="errors.length">
      <h2 class="mt-3 mb-3 text-center">Errors:</h2>
      <div class="row text-center">
        <div v-for="(error, index) in errors" class="col-12" :key="index">
          <div class="alert alert-danger" role="alert">
            Reason: {{ error.message }} URL: {{ error?.config?.url }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import MagratheaCard from "@/components/MagratheaCard.vue";
import ProfileCardSkeleton from "@/components/ProfileCardSkeleton.vue";
import Search from "@/components/Search.vue";
import AccountBar from "@/components/AccountBar.vue";
import AccountBarSkeleton from "@/components/AccountBarSkeleton.vue";
import NumberCard from "@/components/NumberCard.vue";
import TwilioCard from "@/components/TwilioCard.vue";
import NumberList from "@/components/NumberList.vue";
import Welcome from "@/components/Welcome.vue";
import { SearchByAccountNumber } from "@/services/number.js";
import usePromise from "@/composables/use-promise";

import { onErrorCaptured, ref, watch } from "vue";
let number = ref("");
let numberList = ref(null);
let accountIdSearch = ref(null);
let numberReset = ref(false);
let accountReset = ref(false);
let carrierType = ref("");

const numberTiles = 10;
const numberSearch = (tel) => {
  number.value = tel;
  numberList.value = null;
  accountReset.value = true;
  numberReset.value = false;
};
const numberByAccountSearch = async (accountId) => {
  if (!accountId) return;
  numberReset.value = true;
  accountReset.value = false;
  accountIdSearch.value = accountId;
  const numbersByAccount = usePromise(() => SearchByAccountNumber(accountId));
  await numbersByAccount.run();
  numberList.value = numbersByAccount.results.value.numbers;
};

const numberUpdated = (num) => {
  number.value = num;
};
const carrierTypeUpdated= (carrier) =>
{
  carrierType.value = carrier;
};

const errors = ref([]);
onErrorCaptured((e) => {
  errors.value.push(e);
  return true;
});
// Reset error when number is updated
watch(number, () => (errors.value = []));
</script>

<style>
.card-header.bg1 {
  background-color: #379683;
}
.card-header.bg2 {
  background-color: #55bcc9;
}
.card-header.bg3 {
  background-color: #ff768f;
}
.card-header.bg4 {
  background-color: #86b3d1;
}
.card-header.bg5 {
  background-color: #4d6d9a;
}
.card-header.bg6 {
  background-color: #9589bd;
}
.card-header.bg7 {
  background-color: #969696;
}
.card-header.bg8 {
  background-color: #026670;
}
.card-header.bg9 {
  background-color: #254e58;
}
.card-header.bg10 {
  background-color: #46344e;
}
.card-header.bg11 {
  background-color: #3170be;
}

.card-title {
  font-size: 1.1rem;
}
@media screen and (max-width: 1200px) {
  .card-title {
    font-size: 1rem;
  }
  .card-body p {
    font-size: 0.8rem;
  }
}
</style>
